/** Anzeige-Label für Header, Footer, Mobile-Shell (eine Quelle der Wahrheit) */
export const APP_VERSION_LABEL = 'Version 1.5';

/** Footer-Copyright (Mobile + Desktop) */
export const COPYRIGHT_YEAR = 2026;

export const COPYRIGHT_LABEL = `© ${COPYRIGHT_YEAR} V3Tax`;
